
import { Link } from "react-router-dom";
import { Alert, AlertDescription, AlertTitle } from "@/components/ui/alert";
import { Button } from "@/components/ui/button";
import { Info } from "lucide-react";
import { useTranslation } from "react-i18next";

interface UserListingsAlertsProps {
  showFreeTierAlert: boolean;
  approvedListingsCount: number;
}

export const UserListingsAlerts = ({ showFreeTierAlert, approvedListingsCount }: UserListingsAlertsProps) => {
  const { t } = useTranslation('common');
  
  if (!showFreeTierAlert) return null;

  return (
    <Alert variant="default" className="mb-6 border-amber bg-amber-soft">
      <Info className="h-5 w-5 text-amber-600" />
      <AlertTitle>{t("listings.alerts.freeTierTitle")}</AlertTitle>
      <AlertDescription className="text-brand-ink">
        {t("listings.alerts.freeTierDescription")}
        {approvedListingsCount > 1 && t("listings.alerts.additionalListingsRejected")}
        {t("listings.alerts.upgradePrompt")}
        <div className="mt-2">
          <Link to="/pricing">
            <Button size="sm" variant="secondary" className="bg-brand-ink text-white hover:bg-brand-charcoal">
              {t("listings.alerts.upgradeButton")}
            </Button>
          </Link>
        </div>
      </AlertDescription>
    </Alert>
  );
};
